import { Pipe, PipeTransform } from '@angular/core';
import Autolinker from 'autolinker';

@Pipe({ name: 'autoLinkUrl' })
export class AutoLinkUrlPipe implements PipeTransform {
  transform(value: string): string {
    return Autolinker.link(value);
  }
}
